import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=1279a8a0"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1279a8a0')) {
      api.createRecord('1279a8a0', component.options)
    } else {
      api.reload('1279a8a0', component.options)
    }
    module.hot.accept("./Admin.vue?vue&type=template&id=1279a8a0", function () {
      api.rerender('1279a8a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/Admin.vue"
export default component.exports